




















































import { defineComponent, PropType } from '@vue/composition-api'
import { carCategoryController, carOfficeController } from '~/api/RentalCar'
import Autocomplete from '~/components/Autocomplete.vue'
import DateTimePicker from '~/components/DateTimePicker.vue'
import { VueForm } from '~/utils/interfaces'
import { CreateCarBooking } from '~/utils/interfaces/rentalCar'
import vRules from '~/utils/vRules'

export default defineComponent({
  components: { DateTimePicker, Autocomplete },
  props: {
    crud: {
      type: Object as PropType<CreateCarBooking>,
      required: true,
    },
  },
  data() {
    return {
      vRules,
    }
  },
  methods: {
    getCarOffices: carOfficeController.getter,
    getCarCategories: carCategoryController.getter,
    onNext() {
      return (this.$refs.form as VueForm).validate()
    },
  },
})
